import userService from "../../../services/user.service";

async function addPlan({
  userId,
  month,
  year,
  planDate,
  cityId,
  startTime,
  endTime,
  practiceLocationId,
}) {
  try {
    const response = await userService.addPlan({
      employeePlanId: 0,
      employeeId: userId,
      month: month,
      year: year,
      employeePlanDate: {
        employeePlanDateId: 0,
        planDate: planDate,
        planDetails: [
          {
            id: 0,
            cityId: cityId,
            startTime: startTime,
            endTime: endTime,
            practiceLocationId: practiceLocationId,
            doctorId: null,
            headOffice: false,
          },
        ],
      },
    });
    if (response.data && response.data.status) {
      console.log(response.data);
      return JSON.stringify(response.data);
    } else {
      return JSON.stringify(response.data.message) || "Failed to add Plan.";
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    return JSON.stringify(errorMessage);
  }
}

export default {
  addPlan,
  planTools: [
    {
      type: "function",
      function: {
        name: "addPlan",
        description: `Add a new employee plan including practice location for a specific date. 
                First user will choose the month, year, planDate startTime and endTime. 
                Then user will select city from the cities. 
                Then you will get all practice location in that specific city. 
                Then user will select the practice location. 
                you will use all that data to add the plan.`,
        parameters: {
          type: "object",
          properties: {
            userId: {
              type: "integer",
              description:
                "The ID of the user (employee) for whom the plan is being added. You can get this id be using the getUserDetails function. dont get this from user",
            },
            month: {
              type: "integer",
              description:
                "The month for which the plan is being added. (1-12). this will generate from the planDate. So you not need to get this from user. You will just derive it from planDate parameter.",
            },
            year: {
              type: "integer",
              description:
                "The year for which the plan is being added.(i.e. 2025). this will generate from the planDate. So you not need to get this from user. You will just derive it from planDate parameter.",
            },
            planDate: {
              type: "string",
              format: "date-time",
              description: "The specific date of the plan in ISO format.",
            },
            cityId: {
              type: "integer",
              description:
                "The ID of the city where the practice location is located.",
            },
            startTime: {
              type: "string",
              description: "The start time of the plan in HH:mm:ss format.",
            },
            endTime: {
              type: "string",
              description: "The end time of the plan in HH:mm:ss format.",
            },
            practiceLocationId: {
              type: "integer",
              description: "The ID of the practice location.",
            },
          },
          required: [
            "userId",
            "month",
            "year",
            "planDate",
            "cityId",
            "startTime",
            "endTime",
            "practiceLocationId",
          ],
        },
      },
    }
  ]
};
